import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { AppLayout } from '@/layouts/app-layout';
import { getAuthState } from '@/stores/auth.store';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    const { accessToken, user } = getAuthState();

    // Only check for token - user data is fetched by AuthProvider
    if (!accessToken) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }

    // Require verified email before anything else
    if (user && !user.emailVerified) {
      throw redirect({
        to: '/verify-email',
      });
    }

    // Redirect to account setup if not completed (only if user is loaded)
    if (user && !user.accountSetupComplete) {
      throw redirect({
        to: '/account-setup',
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
